export var cloneElement = function (deep, el) {
    if (deep === void 0) { deep = true; }
    return el.cloneNode(deep);
};
